import { render, staticRenderFns } from "./incomeDetails.vue?vue&type=template&id=6ecfe7db&scoped=true"
import script from "./incomeDetails.vue?vue&type=script&lang=js"
export * from "./incomeDetails.vue?vue&type=script&lang=js"
import style0 from "./incomeDetails.vue?vue&type=style&index=0&id=6ecfe7db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecfe7db",
  null
  
)

export default component.exports